import { Carousel } from 'bootstrap';

function initializeBootstrapCarousels(): void {
  const bootstrapCarousels = document.querySelectorAll('.carousel');

  bootstrapCarousels.forEach(c => {
    const carousel = new Carousel(c);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeBootstrapCarousels();
});
